import { create } from "zustand";
import { persist } from "zustand/middleware";

interface StoreState {
  isAuthenticated: boolean;
  loading: boolean;
  setIsAuthenticated: (value: boolean) => void;
  setLoading: (value: boolean) => void;
  logout: () => void;
}

export const useStore = create(
  persist<StoreState>(
    (set) => ({
      isAuthenticated: false,
      loading: true,
      setIsAuthenticated: (value: boolean) => set({ isAuthenticated: value }),
      setLoading: (value: boolean) => set({ loading: value }),
      logout: () => {
        set({ isAuthenticated: false, loading: false });
        localStorage.removeItem("auth-storage");
      },
    }),
    {
      name: "auth-storage",
    }
  )
);